import { Prescription, Exercise } from "../../../../../types";

interface PrescriptionHeaderProps {
  readonly index: number;
  readonly prescription: Prescription;
  readonly originalPrescription?: Prescription;
  readonly isEditing: boolean;
  readonly exercisesList: Exercise[];
  readonly onNameChange: (name: string) => void;
}

export function PrescriptionHeader({
  index,
  prescription,
  originalPrescription,
  isEditing,
  exercisesList,
  onNameChange,
}: PrescriptionHeaderProps) {
  if (isEditing) {
    return (
      <div className="mb-4 sm:mb-6 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <div className="flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-xl bg-gradient-to-br from-purple-600 to-purple-600 text-lg sm:text-xl font-bold text-white shadow-sm">
          {String.fromCodePoint(65 + index)}
        </div>
        <div className="flex-1 w-full sm:w-auto">
          <label
            htmlFor="exercise-id"
            className="mb-2 block text-xs font-medium text-gray-600 dark:text-gray-400"
          >
            Nome do Treino
          </label>
          <select
            id="exercise-id"
            name="id"
            required
            value={prescription.id}
            onChange={(e) => onNameChange(e.target.value)}
            className="w-full appearance-none rounded border border-stroke bg-transparent py-2.5 sm:py-3 px-4 sm:px-5 text-sm sm:text-base outline-none transition focus:border-primary dark:border-form-strokedark dark:bg-form-input text-black dark:text-white"
          >
            <option value="" disabled>
              Selecione um exercício
            </option>
            {exercisesList.map((exercise) => (
              <option key={exercise.id} value={exercise.id}>
                {exercise.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }

  const hasOriginal = !!originalPrescription;

  return (
    <>
      <div className="flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-xl bg-gradient-to-br from-purple-600 to-purple-600 text-lg sm:text-xl font-bold text-white shadow-sm">
        {String.fromCodePoint(65 + index)}
      </div>
      <div className="flex-1 min-w-0">
        {hasOriginal ? (
          <div className="flex flex-col gap-0.5 sm:gap-1">
            <span className="text-xs sm:text-sm text-gray-500 line-through dark:text-gray-400 truncate">
              {originalPrescription.name}
            </span>
            <span className="text-sm sm:text-base font-bold text-purple-600 dark:text-purple-400 truncate">
              {prescription.name}
            </span>
          </div>
        ) : (
          <span className="text-sm sm:text-base font-bold text-purple-600 dark:text-purple-400 truncate">
            {prescription.name}
          </span>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          {prescription.exercises?.length || 0}{" "}
          {(prescription.exercises?.length || 0) === 1
            ? "exercício"
            : "exercícios"}
        </p>
      </div>
    </>
  );
}
